import { LocalizationStore } from './LocalizationStore';

export default LocalizationStore;
